import script from "./YouTubeListView.vue?vue&type=script&setup=true&lang=js"
export * from "./YouTubeListView.vue?vue&type=script&setup=true&lang=js"

import "./YouTubeListView.vue?vue&type=style&index=0&id=06d9f620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d9f620"]])

export default __exports__